import { SetRequired } from 'type-fest';

import { parseDate } from '@occc-app/lib/date';
import { PeriodOfThePurchase, PeriodValues, TransactionTimePeriod } from '../../../types';

type RollingWindowPeriod = SetRequired<Partial<PeriodOfThePurchase>, 'timeWindow'> & {
  timePeriodType: TransactionTimePeriod.RollingWindow;
};

type FixedMonthPeriod = SetRequired<Partial<PeriodOfThePurchase>, 'fixedMonth'> & {
  timePeriodType: TransactionTimePeriod.FixedMonth;
};

type FixedWindowPeriod = SetRequired<Partial<PeriodOfThePurchase>, 'fixedWindow'> & {
  timePeriodType: TransactionTimePeriod.FixedWindow;
};

type PreviousMonthPeriod = Partial<PeriodOfThePurchase> & {
  timePeriodType: TransactionTimePeriod.PreviousMonth;
};

type AllTimePeriod = Partial<PeriodOfThePurchase> & {
  timePeriodType: TransactionTimePeriod.AllTime;
};

export type TimePeriodFormValues =
  | RollingWindowPeriod
  | FixedMonthPeriod
  | FixedWindowPeriod
  | PreviousMonthPeriod
  | AllTimePeriod;

export const convertDateConditionToInitialFormValues = ({
  startDate,
  endDate,
  targetMonth,
  targetYear,
  timeWindow,
  relativeMonthsBack,
}: PeriodValues): TimePeriodFormValues => {
  const isRollingWindow = !!timeWindow;
  const isFixedMonth = !!(targetMonth && targetYear);
  const isFixedWindow = !!(startDate && endDate);

  if (isRollingWindow) {
    return {
      timePeriodType: TransactionTimePeriod.RollingWindow,
      timeWindow,
    };
  }

  if (isFixedMonth) {
    const fixedMonth = new Date(targetYear, targetMonth - 1);

    return {
      timePeriodType: TransactionTimePeriod.FixedMonth,
      fixedMonth,
    };
  }

  if (isFixedWindow) {
    return {
      timePeriodType: TransactionTimePeriod.FixedWindow,
      fixedWindow: {
        startDate: parseDate(startDate),
        endDate: parseDate(endDate),
      },
    };
  }

  if (relativeMonthsBack === 1) {
    return {
      timePeriodType: TransactionTimePeriod.PreviousMonth,
    };
  }

  return {
    timePeriodType: TransactionTimePeriod.AllTime,
  };
};
